
(function () {
  // ---------------- CONFIG ----------------
  var CONTAINER_SEL = '.product__block.product__block--variant_picker';

  var GROUP_LABELS = [
    // 'Chiropedic Bed Base (Bedding size)',
    // 'Yinahla Classic Comfort Mattress (Bedding size)',
    // 'Third Product (Bedding size)',
    // 'Fourth Product (Bedding size)'
  ];

  // Which group is the master when doing the first alignment (0..3). Default: first found.
  var MASTER_INDEX = 0;

  // Per-group value mappings (canonical -> group value)
  var VALUE_MAPS = { 0: {}, 1: {}, 2: {}, 3: {} };

  // Mirror-disable markers
  var MIRROR_ATTR = 'data-bedsync4-mirrored';
  var MIRROR_LABEL_CLASS = 'bedsync4-disabled';

  // -------------- HELPERS ---------------
  function $container() {
    var $c = $(CONTAINER_SEL).first();
    return $c.length ? $c : $(document);
  }

  function textOfLegend($fs) {
    var $legend = $fs.find('legend').first();
    if (!$legend.length) return '';
    var bold = $.trim($legend.find('.font-body-bolder').first().text() || '');
    var all  = $.trim($legend.text() || '');
    return bold || all;
  }

  function findFieldsets($root) {
    // If labels provided, pick them in order (best)
    if (GROUP_LABELS && GROUP_LABELS.length) {
      var out = [];
      var lowers = GROUP_LABELS.map(function(s){ return (s||'').toLowerCase(); });
      $root.find('fieldset.product-form__input').each(function() {
        var txt = (textOfLegend($(this)) || '').toLowerCase();
        lowers.forEach(function(needle, idx){
          if (!out[idx] && needle && txt.indexOf(needle) > -1) out[idx] = $(this);
        }, this);
      });
      return out.filter(Boolean).slice(0, 4);
    }

    // Fallback: first try legends containing "Bedding size"
    var $all = $root.find('fieldset.product-form__input');
    var matchBedding = $all.filter(function(){
      return /bedding\s*size/i.test(textOfLegend($(this)) || '');
    }).slice(0, 4).toArray().map(function(el){ return $(el); });

    if (matchBedding.length >= 4) return matchBedding;

    // Then fall back to any legend containing "Size"
    var extra = $all.filter(function(){
      return /(^|\b)size\b/i.test(textOfLegend($(this)) || '');
    }).toArray().map(function(el){ return $(el); });

    // Merge unique and cap at 4
    var set = [];
    matchBedding.concat(extra).some(function($fs){
      if (!set.some(function($x){ return $x.get(0) === $fs.get(0); })) set.push($fs);
      return set.length >= 4;
    });
    return set;
  }

  function radiosInFieldset($fs) {
    return $fs.find('input[type=radio]');
  }

  function getVal($group) {
    var $c = $group.filter(':checked');
    return $c.length ? ($c.val() || '').trim() : '';
  }

  function hasVal($group, val) {
    var t = '';
    $group.each(function(){ if ($.trim(this.value) === val) { t = val; return false; }});
    return !!t;
  }

  // IMPORTANT: theme may use aria-disabled/data-option-available instead of disabled attr
  function isSelectable($radio) {
    if ($radio.attr(MIRROR_ATTR) === 'true') return false;

    var ava = $radio.attr('data-option-available');
    if (typeof ava !== 'undefined' && String(ava).toLowerCase() === 'false') return false;

    var aria = ($radio.attr('aria-disabled') || '').toLowerCase();
    if (aria === 'true') return false;

    if ($radio.hasClass('disabled')) return false;
    if ($radio.is(':disabled')) return false;

    return true;
  }

  function setVal($group, val) {
    var $t = $group.filter(function(){ return $.trim(this.value) === val; });
    if (!$t.length) return false;
    if (!isSelectable($t)) return false;
    if ($t.prop('checked')) return false;            // avoid redundant click
    $t.trigger('click');                              // let theme handle updates
    return true;
  }

  function updateCaption($fs, value) {
    var $cap = $fs.find('[data-selected-swatch-value]');
    if ($cap.length) $cap.text(value);
  }

  // Mapping helpers: convert between a group's value and a canonical value
  function toCanonical(idx, groupVal) {
    groupVal = (groupVal || '').trim();
    var m = VALUE_MAPS[idx] || {};
    var inv = {};
    Object.keys(m).forEach(function(can){ inv[(m[can]||'').trim()] = can; });
    return inv[groupVal] || groupVal; // default: identity
  }
  function fromCanonical(idx, canonical) {
    canonical = (canonical || '').trim();
    var m = VALUE_MAPS[idx] || {};
    return (m.hasOwnProperty(canonical) ? m[canonical] : canonical);
  }

  // ---------- MIRROR DISABLE (NEW) ----------
  function injectCSSOnce() {
    if (document.getElementById('bedsync4-css')) return;
    var css = document.createElement('style');
    css.id = 'bedsync4-css';
    css.textContent = `
      /* Block clicks and show visually disabled for mirrored options */
      ${CONTAINER_SEL} label.${MIRROR_LABEL_CLASS} {
        pointer-events: none;
        opacity: 0.55;
        position: relative;
      }
      ${CONTAINER_SEL} label.${MIRROR_LABEL_CLASS}::after {
        content: "";
        position: absolute;
        left: 8px;
        right: 8px;
        top: 50%;
        height: 1px;
        transform: rotate(-25deg);
        background: currentColor;
        opacity: 0.75;
      }
    `;
    document.head.appendChild(css);
  }

  function isThemeUnavailableRadio($radio) {
    // Ignore ones we mirrored-disable
    if ($radio.attr(MIRROR_ATTR) === 'true') return false;

    var ava = $radio.attr('data-option-available');
    if (typeof ava !== 'undefined' && String(ava).toLowerCase() === 'false') return true;

    var aria = ($radio.attr('aria-disabled') || '').toLowerCase();
    if (aria === 'true') return true;

    if ($radio.hasClass('disabled')) return true;
    if ($radio.is(':disabled')) return true;

    return false;
  }

  function clearMirroredDisable($radio) {
    if ($radio.attr(MIRROR_ATTR) !== 'true') return;

    $radio.removeAttr(MIRROR_ATTR);

    // Only remove OUR UI hook — do not force available=true (theme may keep it unavailable)
    var id = $radio.attr('id');
    if (id) $('label[for="' + id.replace(/"/g, '\\"') + '"]').removeClass(MIRROR_LABEL_CLASS);

    // If label wrapping pattern exists, remove from closest label too
    $radio.closest('label').removeClass(MIRROR_LABEL_CLASS);
  }

  function applyMirroredDisable($radio) {
    $radio.attr(MIRROR_ATTR, 'true');

    // Mirror theme signals (this theme often relies on these)
    $radio.attr('data-option-available', 'false');
    $radio.attr('aria-disabled', 'true');

    var id = $radio.attr('id');
    if (id) $('label[for="' + id.replace(/"/g, '\\"') + '"]').addClass(MIRROR_LABEL_CLASS);

    // If input is wrapped by label
    $radio.closest('label').addClass(MIRROR_LABEL_CLASS);
  }

  function allGroups($root) {
    var $sets = findFieldsets($root).slice(0, 4);  // at most 4
    return $sets.map(function($fs){ return { $fs: $fs, $radios: radiosInFieldset($fs) }; });
  }

  function syncDisabledStates($root) {
    var groups = allGroups($root);
    if (groups.length < 2) return;

    // 1) Clear previous mirrored disables (fresh recompute)
    groups.forEach(function(g){
      g.$radios.each(function(){ clearMirroredDisable($(this)); });
    });

    // 2) Build canonical -> unavailable map (OR logic)
    var unavailable = {};
    groups.forEach(function(g, idx){
      g.$radios.each(function(){
        var $r = $(this);
        var v = $.trim($r.val() || '');
        if (!v) return;
        var canonical = toCanonical(idx, v);
        if (!canonical) return;
        if (isThemeUnavailableRadio($r)) unavailable[canonical] = true;
      });
    });

    // 3) Apply mirrored disable everywhere for those canonicals
    groups.forEach(function(g, idx){
      g.$radios.each(function(){
        var $r = $(this);
        var v = $.trim($r.val() || '');
        if (!v) return;
        var canonical = toCanonical(idx, v);
        if (unavailable[canonical]) applyMirroredDisable($r);
      });
    });
  }

  function syncDisabledStatesSoon() {
    var $root = $container();
    if (!$root || !$root.length) return;

    syncDisabledStates($root);

    // Run again after possible async theme updates/re-render
    setTimeout(function(){
      var $r2 = $container();
      if ($r2 && $r2.length) syncDisabledStates($r2);
    }, 120);
  }

  // -------------- CORE SYNC --------------
  var isSyncing = false;

  function alignOnce($root) {
    var groups = allGroups($root);
    if (groups.length < 2) return;           // need at least two; supports up to 4

    // Pick a master (first with a value); fall back to MASTER_INDEX
    var masterIdx = -1, canonical = '';
    groups.forEach(function(g, idx){
      if (masterIdx !== -1) return;
      var v = getVal(g.$radios);
      if (v) { masterIdx = idx; canonical = toCanonical(idx, v); }
    });
    if (masterIdx === -1 && groups[MASTER_INDEX]) {
      var v0 = getVal(groups[MASTER_INDEX].$radios);
      if (v0) { masterIdx = MASTER_INDEX; canonical = toCanonical(MASTER_INDEX, v0); }
    }
    if (masterIdx === -1 || !canonical) return;

    isSyncing = true;
    groups.forEach(function(g, idx){
      var targetVal = fromCanonical(idx, canonical);
      if (!targetVal) return;
      if (getVal(g.$radios) !== targetVal && hasVal(g.$radios, targetVal)) {
        setVal(g.$radios, targetVal);
      }
      updateCaption(g.$fs, targetVal);
    });
    setTimeout(function(){ isSyncing = false; }, 30);

    // NEW: mirror-disable after initial align
    syncDisabledStatesSoon();
  }

  function onAnyChange(e) {
    if (isSyncing) return;

    var $root = $container();
    var groups = allGroups($root);
    if (groups.length < 2) return;

    // Only care about radio changes
    var $t = $(e.target);
    if (!$t.is('input[type=radio]')) return;

    // Which group fired?
    var srcIdx = -1;
    groups.forEach(function(g, idx){
      if (srcIdx !== -1) return;
      if ($.contains(g.$fs.get(0), e.target)) srcIdx = idx;
    });
    if (srcIdx === -1) return;

    var src = groups[srcIdx];
    var srcVal = getVal(src.$radios);
    if (!srcVal) return;

    var canonical = toCanonical(srcIdx, srcVal);

    isSyncing = true;
    groups.forEach(function(g, idx){
      if (idx === srcIdx) { updateCaption(g.$fs, srcVal); return; }

      var targetVal = fromCanonical(idx, canonical);
      if (!targetVal) return;

      if (getVal(g.$radios) === targetVal) {
        updateCaption(g.$fs, targetVal);
        return;
      }

      if (hasVal(g.$radios, targetVal)) {
        setVal(g.$radios, targetVal);       // ignored if unavailable/mirrored
        updateCaption(g.$fs, targetVal);
      }
    });
    setTimeout(function(){ isSyncing = false; }, 30);

    // NEW: mirror-disable after changes (and after re-render)
    syncDisabledStatesSoon();
  }

  function boot() {
    if (!window.jQuery) {
      console.warn('[VariantSync4] jQuery not found. Load jQuery before this script.');
      return;
    }

    injectCSSOnce();

    var $root = $container();

    // Clean old handlers
    $(document).off('.bedSync4');

    // Delegate so it survives dynamic re-renders
    $(document).on('change.bedSync4 click.bedSync4', 'fieldset.product-form__input input[type=radio]', onAnyChange);

    // Initial alignment + disable mirror
    alignOnce($root);

    // Re-align on Shopify section events
    $(document).on('shopify:section:load.bedSync4 shopify:section:select.bedSync4 shopify:section:deselect.bedSync4 shopify:section:unload.bedSync4', function(){
      alignOnce($container());
    });

    // MutationObserver to re-apply mirror-disable on re-render
    var el = $root && $root.get(0);
    if (window.MutationObserver && el) {
      var t;
      var mo = new MutationObserver(function(){
        clearTimeout(t);
        t = setTimeout(function(){
          syncDisabledStatesSoon();
        }, 80);
      });
      mo.observe(el, { childList: true, subtree: true, attributes: true });
    }

    console.log('[VariantSync4] four-field size sync + mirror-disable active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();